'use strict';

exports.__esModule = true;
exports.getTranslationsForKey = exports.setGlobalTranslations = exports.setLocalTranslations = exports.updateLanguage = exports.UPDATE_LANGUAGE = exports.SET_LOCAL_TRANSLATIONS = exports.SET_GLOBAL_TRANSLATIONS = exports.GLOBAL_TRANSLATIONS_KEY = exports.DEFUALT_LOCALE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// import { LANG, DEFUALT_LANG } from 'store/constants';


var _redux = require('redux');

var _reselect = require('reselect');

var _utils = require('../utils');

var DEFUALT_LOCALE = exports.DEFUALT_LOCALE = 'en';
var GLOBAL_TRANSLATIONS_KEY = exports.GLOBAL_TRANSLATIONS_KEY = 'global';

// export const FETCH_LOCALE_REQUEST     = '@@localize/FETCH_LOCALE_REQUEST';
// export const FETCH_LOCALE_SUCCESS     = '@@localize/FETCH_LOCALE_SUCCESS';
// export const FETCH_LOCALE_ERROR       = '@@localize/FETCH_LOCALE_ERROR';

var SET_GLOBAL_TRANSLATIONS = exports.SET_GLOBAL_TRANSLATIONS = '@@localize/SET_GLOBAL_TRANSLATIONS';
var SET_LOCAL_TRANSLATIONS = exports.SET_LOCAL_TRANSLATIONS = '@@localize/SET_LOCAL_TRANSLATIONS';
var UPDATE_LANGUAGE = exports.UPDATE_LANGUAGE = '@@localize/UPDATE_LANGUAGE';

function translations() {
  var _extends2, _extends3;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case SET_LOCAL_TRANSLATIONS:
      return _extends({}, state, (_extends2 = {}, _extends2[action.payload.key] = action.payload.json, _extends2));
    case SET_GLOBAL_TRANSLATIONS:
      return _extends({}, state, (_extends3 = {}, _extends3[GLOBAL_TRANSLATIONS_KEY] = action.payload, _extends3));
    default:
      return state;
  }
}

function currentLanguage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  var action = arguments[1];

  return action.type === UPDATE_LANGUAGE ? action.payload : state;
}

exports.default = (0, _redux.combineReducers)({
  currentLanguage: currentLanguage,
  translations: translations
});
var updateLanguage = exports.updateLanguage = function updateLanguage(language) {
  var selectedLanguage = language;
  selectedLanguage = selectedLanguage ? selectedLanguage : 'en';
  return {
    type: UPDATE_LANGUAGE,
    payload: selectedLanguage
  };
};

var setLocalTranslations = exports.setLocalTranslations = function setLocalTranslations(key, json) {
  return {
    type: SET_LOCAL_TRANSLATIONS,
    payload: { key: key, json: json }
  };
};

var setGlobalTranslations = exports.setGlobalTranslations = function setGlobalTranslations(json) {
  return {
    type: SET_GLOBAL_TRANSLATIONS,
    payload: json
  };
};

// export const fetchLocaleJson = (json, key): IApiActionType => {
//   return {
//     type: [FETCH_LOCALE_REQUEST, FETCH_LOCALE_SUCCESS, FETCH_LOCALE_ERROR],
//     shouldCallApi: (state) => true,
//     callApi: () => Promise.resolve(json),
//     payload: { key }
//   };
// };

var getCurrentLanguage = function getCurrentLanguage(state) {
  return state.locale.currentLanguage;
};
var getTranslations = function getTranslations(state) {
  return state.locale.translations;
};

var getTranslationsForKey = exports.getTranslationsForKey = function getTranslationsForKey(key) {
  return (0, _reselect.createSelector)(getCurrentLanguage, getTranslations, function (currentLanguage, translations) {
    var globalTranslations = {};
    var localTranslations = {};

    if (translations && (0, _utils.isDefinedNested)(translations, GLOBAL_TRANSLATIONS_KEY)) {
      globalTranslations = translations.global[currentLanguage] || {};
    }

    if (translations && (0, _utils.isDefinedNested)(translations, key, currentLanguage)) {
      localTranslations = translations[key][currentLanguage];
    }

    return _extends({}, globalTranslations, localTranslations);
  });
};